export default __webpack_public_path__ + "static/char-06-634ccfc33cc5ce1df2d723a1e5d79f83.webp";